import React from 'react';
import { Globe, AlertCircle, FileText, Clock } from 'lucide-react';
import { FeaturePreview } from './FeaturePreview';

/**
 * Feature preview component for Public Leaks feature
 * Displays information about the Public Leaks feature and its benefits
 */
export const PublicLeaksFeaturePreview: React.FC = () => {
  return (
    <FeaturePreview
      title="Public Leaks Monitoring"
      description="Monitor and detect exposed credentials and sensitive data in publicly available data breaches and leaks."
      icon={<Globe className="h-8 w-8 text-blue-600" />}
      featureName="public-leaks"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {/* Feature Card 1 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Globe className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Public Breach Monitoring</h3>
          </div>
          <p className="text-gray-400">
            Continuously monitor public data breaches for credentials and sensitive information related to your organization.
          </p>
        </div>

        {/* Feature Card 2 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <AlertCircle className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Exposure Detection</h3>
          </div>
          <p className="text-gray-400">
            Detect exposed credentials, email addresses, and other sensitive data in public forums, paste sites, and data dumps.
          </p>
        </div>

        {/* Feature Card 3 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <FileText className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Detailed Analysis</h3>
          </div>
          <p className="text-gray-400">
            Get detailed analysis of leaked data including affected accounts, breach sources, and exposure timeline.
          </p>
        </div>

        {/* Feature Card 4 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Clock className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Historical Coverage</h3>
          </div>
          <p className="text-gray-400">
            Access historical breach data to understand your organization's exposure over time and identify recurring patterns.
          </p>
        </div>
      </div>
    </FeaturePreview>
  );
};
